import InviraRolesCopy from './InviraRolesCopy.vue'
export {InviraRolesCopy}
export default InviraRolesCopy

